<script>
import { mapState } from "vuex";
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Matriz from "@/components/widgets/network-matriz";

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
    Matriz,
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  data() {
    return {
      loading: false,
      matriz: null,
    };
  },
  methods: {
    getMatriz() {
      this.loading = true;

      api.get("network/matriz").then((response) => {
        if (response.data.status == "success") {
          this.matriz = response.data.matriz;
        } else {
          this.matriz = null;
        }

        this.loading = false;
      });
    },
  },
  mounted() {
    this.getMatriz();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Rede</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Matriz') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <Matriz :data="matriz"></Matriz>
      </div>
    </div>

    <div id="legends" class="d-md-flex flex-wrap justify-content-center flex-gap-5 align-items-center">
      <div class="d-flex justify-content-center align-items-center bg-light text-dark rounded p-2">
        <div class="ml-1 mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"></path>
          </svg>
        </div>
        <span class="mr-2">Indicados</span>
      </div>
      <div class="d-flex justify-content-center align-items-center bg-light text-dark rounded p-2">
        <div class="ml-1 mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5 4.5 6.505 4.5 8.5 6.005 12 8 12z">
            </path>
          </svg>
        </div>
        <span class="mr-2">Equipe</span>
      </div>
      <div class="d-flex justify-content-center align-items-center bg-light text-dark rounded p-2">
        <div class="ml-1 mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path
              d="m17,13c-1.1,0-2-.9-2-2v-.36c0-.47.15-.91.43-1.23.91-1.07,1.26-2.49.96-3.88-.35-1.66-1.7-3.03-3.35-3.4-1.37-.31-2.77,0-3.85.86s-1.7,2.14-1.7,3.52c0,1.08.39,2.12,1.1,2.94.26.3.4.73.4,1.2v.36c0,1.1-.9,2-2,2-2.21,0-4,1.79-4,4v1c0,.55.45,1,1,1h16c.55,0,1-.45,1-1v-1c0-2.21-1.79-4-4-4Zm-12,4c0-1.1.9-2,2-2,2.21,0,4-1.79,4-4v-.36c0-.96-.32-1.85-.89-2.51-.39-.45-.61-1.03-.61-1.63,0-.76.34-1.48.94-1.96.61-.49,1.38-.65,2.16-.48.9.21,1.64.96,1.84,1.87.17.8-.02,1.57-.53,2.17-.59.69-.91,1.59-.91,2.53v.36c0,2.21,1.79,4,4,4,1.1,0,2,.9,2,2H5Z">
            </path>
            <path d="M3 20H21V22H3z"></path>
          </svg>
        </div>
        <span class="mr-2">Nomes (Pessoal / Equipe)</span>
      </div>
      <div class="d-flex justify-content-center align-items-center bg-light text-dark rounded p-2">
        <span class="ml-1 mr-2" style="width: 20px; height: 20px; background-color: #edd100; border-radius: 100%;"></span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"></path><path d="M10.996 12.556 9.7 11.285l-1.4 1.43 2.704 2.647 4.699-4.651-1.406-1.422z"></path></svg>
        <span class="mr-2">Pessoal</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"></path></svg>
        <span class="mr-2">Equipe</span>
      </div>
      <div class="d-flex justify-content-center align-items-center bg-light text-dark rounded p-2">
        <span class="ml-1 mr-2" style="width: 20px; height: 20px; background-color: #00c903; border-radius: 100%;"></span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"></path><path d="M10.996 12.556 9.7 11.285l-1.4 1.43 2.704 2.647 4.699-4.651-1.406-1.422z"></path></svg>
        <span class="mr-2">Pessoal</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"></path><path d="M10.996 12.556 9.7 11.285l-1.4 1.43 2.704 2.647 4.699-4.651-1.406-1.422z"></path></svg>
        <span class="mr-2">Equipe</span>
      </div>
      <div class="d-flex justify-content-center align-items-center bg-light text-dark rounded p-2">
        <span class="ml-1 mr-2" style="width: 20px; height: 20px; background-color: #003de5; border-radius: 100%;"></span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"></path></svg>
        <span class="mr-2">Pessoal</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"></path><path d="M10.996 12.556 9.7 11.285l-1.4 1.43 2.704 2.647 4.699-4.651-1.406-1.422z"></path></svg>
        <span class="mr-2">Equipe</span>
      </div>
      <div class="d-flex justify-content-center align-items-center bg-light text-dark rounded p-2">
        <span class="ml-1 mr-2" style="width: 20px; height: 20px; background-color: #FF0000; border-radius: 100%;"></span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"></path></svg>
        <span class="mr-2">Pessoal</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"></path></svg>
        <span class="mr-2">Equipe</span>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
#legends * {
  line-height: 15px !important;
}

</style>